import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {loginModalPromise} from '~/common/fabric/Card/components/LoginModal/utils/loginModalPromise';
import {userIsLoggedIn} from '~/common/fabric/User/reducers/user';

export const useRequestLogin = () => {
  const dispatch = useDispatch();
  const loggedIn = useSelector(userIsLoggedIn);

  const requestLogin = useCallback(async () => {
    if (!loggedIn) {
      // we need to handle this promise like this
      // eslint-disable-next-line no-return-await
      return await loginModalPromise(dispatch)
        .then(() => true)
        .catch(() => false);
    }

    return loggedIn;
  }, [loggedIn, dispatch]);

  return {loggedIn, requestLogin};
};
